import React, { Dispatch, SetStateAction } from 'react';
import { Icon, Modal, Button } from 'ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { ButtonListModal } from '../../../styles/layout/form';
import { useNavigate } from 'react-router-dom';

interface UnauthenticatedModalProps {
  setShowModal: Dispatch<SetStateAction<boolean>>;
  showModal: boolean;
}

const UnverifiedEmail = ({ setShowModal, showModal }: UnauthenticatedModalProps) => {
  const intl = useIntl();
  const navigate = useNavigate();

  const onOk = () => {
    navigate('/main?my-participation=open&tab=notices_tab');
    setShowModal(false);
  };

  return (
    <Modal
      className="unverified-modal"
      onCancel={() => setShowModal(false)}
      open={showModal}
      closable={false}
      disableHeader
      centered
      width={725}
      footer={
        <ButtonListModal>
          <Button
            label={intl.formatMessage({
              id: 'general.cancel',
            })}
            onClick={() => setShowModal(false)}
          />

          <Button
            label={intl.formatMessage({
              id: 'general.specify_email',
            })}
            type="primary"
            onClick={onOk}
          />
        </ButtonListModal>
      }
      getContainer={document.getElementById('root') as HTMLDivElement}
    >
      <h3 className="confirm-title">
        <Icon faBase="fal" icon="exclamation-circle" />
        <FormattedMessage id="general.unverified_email_text" />
      </h3>
    </Modal>
  );
};

export default UnverifiedEmail;
